import { useCallback, useEffect, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, classBorderLabelDark, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul, classBtSemDuration,
    classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, DadosCaixaRelatorio, DadosEmpresaCaixa,
    ResumoRecebimento, ResumoVendas, SangriaSuprimento, Usuarios
} from "../../Utils/Types"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { FaPrint } from "react-icons/fa"
import { IoPrint, IoSearch } from "react-icons/io5"
import { DataSearch, SearchBox } from "../../Components/SearchBox/SearchBox"
import { AiOutlineClear } from "react-icons/ai"
import { CaixaService } from "./CaixaService"
import { UserService } from "../Users/User.service"
import { Funcoes } from "../../Utils/Funcoes"
import moment from "moment"
import { TfiPrinter } from "react-icons/tfi"
import { ModalImpress } from "../../Components/Modal/modal-impress"
import { ReportCaixaBobina } from "./pdf/report-caixa-bobina"
import { ReportCaixaA4 } from "./pdf/report-caixa-A4"

export const RelCaixaDiario = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD');

    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // -----------------------------------------------
    // ------------- ATRIBUTOS -----------------------
    // -----------------------------------------------
    const [data, setData] = useState(dateI)

    // VENDEDOR
    const [usuariosDefault, setUsuariosDefault] = useState<Usuarios[]>([])
    const [usuarios, setUsuarios] = useState<DataSearch[]>([])
    const [idVendedor, setIdVendedor] = useState(0)

    //const [searchBoxResponsivo, setSearchBoxResponsivo] = useState<boolean>(false)

    // -----------------------------------------------
    // ------------- DADOS DAS TABELAS ---------------
    // -----------------------------------------------
    const [empresa, setEmpresa] = useState<DadosEmpresaCaixa>({ bairro: '', cep: 0, cidade: '', cnpj_cpf: '', complemento: '', ie_rg: '', nome_fantasia: '', numero: '', razao: '', endereco: '', uf: '' })
    const [resumoRecebimento, setResumoRecebimento] = useState<ResumoRecebimento[]>([])
    const [resumoVendas, setResumoVendas] = useState<ResumoVendas[]>([])
    const [supSangriaList, setSupSangriaList] = useState<SangriaSuprimento[]>([])
    const [totalSangria, setTotalSangria] = useState(0)
    const [totalSuprimento, setTotalSuprimento] = useState(0)
    const [totalDinheiroVenda, setTotalDinheiroVenda] = useState(0)
    const [totalDinheiroRecebimento, setTotalDinheiroRecebimento] = useState(0)

    const [totalGeralVendas, setTotalGeralVendas] = useState(0)
    const [totalGeralRecebimentos, setTotalGeralRecebimentos] = useState(0)
    const [totalGeralSuprimentosSangrias, setTotalGeralSuprimentosSangrias] = useState(0)
    const [totalGeralApuracao, setTotalGeralApuracao] = useState(0)

    const [visibleImpressCaixa, setVisibleImpressCaixa] = useState(false)
    const [visibleImpressCaixaA4, setVisibleImpressCaixaA4] = useState(false)
    const [visibleImpressCaixaBobina, setVisibleImpressCaixaBobina] = useState(false)

    const [visibleSearchBoxUsuario, setVisibleSearchBoxUsuario] = useState<boolean>(false)

    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const getUsuarios = async () => {
        setLoading(true)

        try {

            const resp = await UserService.UsuarioList()

            if (!resp.error) {

                let newUsuariosList: DataSearch[] = resp.data.map((item: { id: number; nome: string }) => { return { id: item.id, description: item.nome } })
                setUsuarios(newUsuariosList)

                setUsuariosDefault(resp.data)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Não foi possivel buscar os usuarios.')

        } finally {
            setLoading(false)
        }
    }

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroCaixa") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxUsuario && !loading && menuFiltro.classList.contains("max-h-[1000px]")) {
            await handleFilterClick()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter);

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter);
        };

    }, [data, idVendedor, visibleSearchBoxUsuario, loading])

    useEffect(() => {
        getUsuarios()
    }, [])

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //----------------------------------------------------------------------- FILTROS ----------------------------------------------------------------------------//
    const dataChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setData(e.target.value)
    }

    const handleLimparFiltros = () => {
        setData(dateI)
        setIdVendedor(0)
        setResumoRecebimento([])
        setResumoVendas([])
        setSupSangriaList([])
        setTotalSangria(0)
        setTotalSuprimento(0)
        setTotalDinheiroVenda(0)
        setTotalDinheiroRecebimento(0)
        setTotalGeralVendas(0)
        setTotalGeralRecebimentos(0)
        setTotalGeralSuprimentosSangrias(0)
        setTotalGeralApuracao(0)
        setVisible(false)

        handleInputFocus()
    }

    const handleFilterClick = async () => {

        setLoading(true)
        setVisible(false)

        try {

            handleInputFocus()

            const relatorio: DadosCaixaRelatorio = {
                data: data,
                id_vendedor: idVendedor
            }

            const relCaixa = await CaixaService.ConsultarCaixa(relatorio);

            if (relCaixa.error) {

                setVisible(true)
                setMessageType('DANGER')
                setMessage(relCaixa.msg || '')

            } else {

                if (relCaixa.data.length > 0) {

                    setEmpresa(relCaixa.data[0].empresa)
                    setResumoRecebimento(relCaixa.data[0].resumo_recebimento)
                    setResumoVendas(relCaixa.data[0].resumo_vendas)
                    setSupSangriaList(relCaixa.data[0].sup_sangrias_list)
                    setTotalSangria(relCaixa.data[0].tot_sangria)
                    setTotalSuprimento(relCaixa.data[0].tot_suprimento)


                    // ---------------------- SOMA DAS VENDAS NA APURAÇÃO ------------------------------------
                    const totalVendasTipo1 = relCaixa.data[0].resumo_vendas
                        .filter((item: any) => item.tipo === "01") // Filtrar os que têm tipo "01"
                        .reduce((acc: any, item: any) => acc + item.valor, 0); // Somar os valores

                    setTotalDinheiroVenda(totalVendasTipo1);


                    // ---------------------- SOMA DOS RECEBIMENTOS NA APURAÇÃO ------------------------------------
                    const totalRecibosTipo1 = relCaixa.data[0].resumo_recebimento
                        .filter((item: any) => item.tipo === "01") // Filtrar os que têm tipo "01"
                        .reduce((acc: any, item: any) => acc + item.valor, 0); // Somar os valores

                    setTotalDinheiroRecebimento(totalRecibosTipo1);

                    // ---------------------- SOMA GERAL ------------------------------------
                    const totalGeralDaVenda = relCaixa.data[0].resumo_vendas.reduce((acc: any, item: any) => acc + item.valor, 0);
                    setTotalGeralVendas(totalGeralDaVenda);

                    const totalGeralDoRecebimento = relCaixa.data[0].resumo_recebimento.reduce((acc: any, item: any) => acc + item.valor, 0);
                    setTotalGeralRecebimentos(totalGeralDoRecebimento);

                    
                    const totalSuprimentos = relCaixa.data[0].sup_sangrias_list.reduce((acc: any, item: any) => {
                        return item.tipo === 'S' ? acc + item.valor : acc;
                    }, 0);

                    const totalSangrias = relCaixa.data[0].sup_sangrias_list.reduce((acc: any, item: any) => {
                        return item.tipo === 'A' ? acc + item.valor : acc;
                    }, 0);

                    const totalGeralDoSupSangria = totalSuprimentos - totalSangrias;
                    setTotalGeralSuprimentosSangrias(totalGeralDoSupSangria);

                    const totalGeralDaApuracao = (relCaixa.data[0].tot_suprimento + totalVendasTipo1 + totalRecibosTipo1 - relCaixa.data[0].tot_sangria)
                    setTotalGeralApuracao(totalGeralDaApuracao)

                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage('Ocorreu um erro ao obter os dados do relatório. Por favor, tente novamente.')

        } finally {
            setLoading(false)
        }
    }

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroCaixa") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsCaixa") as HTMLDivElement

        handleInputFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                //setSearchBoxResponsivo(true)

                menuInputs.classList.remove("invisible")

            } else {

                //setSearchBoxResponsivo(false)

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur();
        }

    }

    const handleInputFocus = () => {
        setVisibleSearchBoxUsuario(false)
    }

    //-------------------------------------------------------------------- USUARIO ----------------------------------------------------------------------------------- ||
    const handlerClearUsuario = () => {
        setUsuariosOriginal()
        setIdVendedor(0)

        setVisibleSearchBoxUsuario(false)
    }

    const handleSetUsuario = (data: DataSearch) => {

        if (data) {
            setUsuariosOriginal()
            setIdVendedor(data.id)
        }

        setVisibleSearchBoxUsuario(false)
    }

    const setUsuariosOriginal = () => {
        let newUsuariosList: any[] = [...usuariosDefault]
        newUsuariosList = usuariosDefault.map(item => { return { id: item.id, description: item.nome } })
        setUsuarios(newUsuariosList)
    }

    const handleFilterUsuario = (descricao: string) => {
        if (descricao.trim() === "") {
            setUsuariosOriginal()
        } else {
            let newUsuariosList = usuariosDefault.filter(item => item.nome.toLocaleLowerCase().startsWith(descricao.toLocaleLowerCase()))
            let newUsuariosSearchList = newUsuariosList.map(item => { return { id: item.id, description: item.nome } })
            setUsuarios(newUsuariosSearchList)
        }
    }

    const clickSearchBoxUser = useCallback(() => {
        setVisibleSearchBoxUsuario((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                inputFocusUser();
            }
            return newState;
        });
    }, []);

    const inputFocusUser = () => {
        let inputSearch = document.getElementById(`inputSearchBox-usuario`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //-------------------------------------------------------------------- IMPRESSÕES ----------------------------------------------------------------------------------- ||
    const ImpirmirCaixa = () => {
        setVisibleImpressCaixa(true)
        handleInputFocus()
    }

    // ------------------------------------------------------------------------- FUNÇÕES DE IMPRESSÃO ----------------------------------------------------------------------
    const imprimirCaixaA4 = () => {
        setVisibleImpressCaixaA4(true)
    }

    const fecharModalCaixaA4 = () => {
        setVisibleImpressCaixaA4(false)
        setVisibleImpressCaixa(false)
    }

    const imprimirCaixaBobina = () => {
        setVisibleImpressCaixaBobina(true)
    }

    const fecharModalCaixaBobina = () => {
        setVisibleImpressCaixaBobina(false)
        setVisibleImpressCaixa(false)
    }

    const fecharModalImpress = () => {
        setVisibleImpressCaixa(false)
    }

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-8 flex flex-row items-center`}>
                            <TfiPrinter className={`mx-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Relatório de caixa</span>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-2`}>

                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtCeuAzul} h-9 disabled:opacity-50 disabled:cursor-not-allowed`} disabled={!(supSangriaList.length > 0) && !(resumoRecebimento.length > 0) && !(resumoVendas.length > 0)} onClick={ImpirmirCaixa} >
                                <IoPrint size="20px" className={`mr-2 hidden md:block`} /> Imprimir
                            </button>

                        </div>

                    </div>

                    <div id='divInputsCaixa' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroCaixa' className={`relative max-h-[0px] h-[310px] sm:h-[180px] xl:h-[100px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-4 px-3`}>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 2xl:col-span-2 mt-3`}>
                                <input id='data-caixa' className={`${classInput} ${classInputDark} dark:[color-scheme:dark] ${data === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' autoComplete='off' value={data} disabled={loading} onFocus={handleInputFocus} onChange={dataChange} />
                                <label htmlFor="data-caixa" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data</label>
                            </div>

                            <div id='componenteVendedor' className={`relative col-span-12 sm:col-span-8 xl:col-span-6 mt-3`}>
                                <SearchBox
                                    dataList={usuarios}
                                    idRegistro={idVendedor}
                                    label='Vendedor'
                                    componentId='usuario'
                                    visibleTAB={visibleSearchBoxUsuario}
                                    setDataClick={handleSetUsuario}
                                    clearDataClick={handlerClearUsuario}
                                    filterDataClick={handleFilterUsuario}
                                    clicado={clickSearchBoxUser}
                                />
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-3`}>
                                <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} `} onClick={handleFilterClick} >
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {!loading && `Pesquisar`} {loading && `Aguarde`}
                                    </span>
                                </button>
                            </div>

                            {/*
                                <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-3`}>
                                <button tabIndex={-1} className={`${classBtSemDuration} ${classbtCinzaClaro} `} onClick={handleLimparFiltros}>
                                    <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                </button>
                            </div>
                            
                            */}


                        </div>

                    </div>

                    <div className={`flex flex-col xl:flex-row`}>

                        <div className={`w-full xl:w-[50%] px-2 py-1 xl:mr-1 mt-2 h-auto min-h-[60px] rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800`}>

                            <div className={`w-full text-center font-semibold dark:text-white mt-1`}>
                                <span className={`text-xl`}>Suprimentos e Sangrias</span>
                            </div>

                            <table className={`my-2 w-full`}>
                                <thead>
                                    <tr className={`bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>
                                        <th className={`w-[20%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>Data</th>
                                        <th className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>Descrição</th>
                                        <th className={`w-[10%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>Tipo</th>
                                        <th className={`w-[20%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>Valor (R$)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {supSangriaList?.map((item: SangriaSuprimento, index: any) => (
                                        <tr key={index} className={`h-10 text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                            <td className={`w-[20%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{moment(item.dh_insert).format("DD/MM/YYYY HH:mm")}</td>
                                            <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{item.observacao}</td>
                                            <td className={`w-[10%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{item.tipo === 'S' ? 'Suprimento' : 'Sangria'}</td>
                                            <td className={`w-[20%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{item.tipo === 'A' ? '-' + Funcoes.numberFormat(item.valor, 'decimal') : Funcoes.numberFormat(item.valor, 'decimal')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <table className={`my-4 w-full`}>

                                <tbody>
                                    <tr className={`text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Total'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalGeralSuprimentosSangrias, 'decimal')}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div className={`w-full xl:w-[50%] px-2 py-1 xl:ml-1 mt-2 h-auto min-h-[60px] rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800`}>

                            <div className={`w-full text-center font-semibold dark:text-white mt-1`}>
                                <span className={`text-xl`}>Resumo das Vendas</span>
                            </div>

                            <table className={`my-2 w-full`}>
                                <thead>
                                    <tr className={`bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>
                                        <th className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>Descrição</th>
                                        <th className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>Valor (R$)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resumoVendas?.map((item: ResumoVendas, index: any) => (
                                        <tr key={index} className={`h-10 text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                            <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{item.descricao}</td>
                                            <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(item.valor, 'decimal')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <table className={`my-4 w-full`}>

                                <tbody>
                                    <tr className={`text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Total'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalGeralVendas, 'decimal')}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                    <div className={`flex flex-col xl:flex-row`}>

                        <div className={`w-full xl:w-[50%] px-2 py-1 xl:mr-1 mt-2 h-auto min-h-[60px] rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800`}>

                            <div className={`w-full text-center font-semibold dark:text-white mt-1`}>
                                <span className={`text-xl`}>Resumo dos Recebimentos</span>
                            </div>

                            <table className={`my-2 w-full`}>
                                <thead>
                                    <tr className={`bg-blue-800 dark:bg-[#3498DB] text-slate-200`}>
                                        <th className={`w-[50%] text-base text-start px-1 border border-slate-300  dark:border-slate-700`}>Descrição</th>
                                        <th className={`w-[50%] text-base text-end px-1 border border-slate-300  dark:border-slate-700`}>Valor (R$)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resumoRecebimento?.map((item: ResumoRecebimento, index: any) => (
                                        <tr key={index} className={`h-10 text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                            <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{item.descricao}</td>
                                            <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(item.valor, 'decimal')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <table className={`my-4 w-full`}>

                                <tbody>
                                    <tr className={`text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Total'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalGeralRecebimentos, 'decimal')}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                        <div className={`w-full xl:w-[50%] px-2 py-1 xl:ml-1 mt-2 h-auto min-h-[60px] rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-md shadow-slate-400 dark:shadow-slate-800`}>

                            <div className={`w-full text-center font-semibold dark:text-white mt-1`}>
                                <span className={`text-xl`}>Apuração Total</span>
                            </div>

                            <table className={`my-2 w-full`}>

                                <tbody>
                                    <tr className={`h-10 text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Suprimentos(+)'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalSuprimento, 'decimal')}</td>
                                    </tr>
                                    <tr className={`h-10 text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Vendas no Dinheiro(+)'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalDinheiroVenda, 'decimal')}</td>
                                    </tr>
                                    <tr className={`h-10 text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Recebimentos no Dinheiro(+)'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalDinheiroRecebimento, 'decimal')}</td>
                                    </tr>
                                    <tr className={`h-10 text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Retiradas(-)'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalSangria, 'decimal')}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className={`my-4 w-full`}>

                                <tbody>
                                    <tr className={`text-black dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                        <td className={`w-[50%] text-base text-start px-1 border border-slate-300 dark:border-slate-700`}>{'Total'}</td>
                                        <td className={`w-[50%] text-base text-end px-1 border border-slate-300 dark:border-slate-700`}>{Funcoes.numberFormat(totalGeralApuracao, 'decimal')}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>

                </div>

                <ModalImpress
                    titulo="Imprimir caixa"
                    msg="Escolha o método de impressão"
                    visible={visibleImpressCaixa}
                    buttonConfirmClickA4={imprimirCaixaA4}
                    buttonConfirmClickBOBINA={imprimirCaixaBobina}
                    closeModalEvent={fecharModalImpress}

                />

                <ReportCaixaBobina
                    visible={visibleImpressCaixaBobina}
                    empresa={empresa}
                    supSangria={supSangriaList}
                    resVendas={resumoVendas}
                    resRecebimentos={resumoRecebimento}
                    totSuprimentos={totalSuprimento}
                    totDinheiroVendas={totalDinheiroVenda}
                    totDinheiroRecebimentos={totalDinheiroRecebimento}
                    totSangrias={totalSangria}
                    totGeralSupSangria={totalGeralSuprimentosSangrias}
                    totGeralVendas={totalGeralVendas}
                    totGeralRecebimentos={totalGeralRecebimentos}
                    totGeralApuracao={totalGeralApuracao}
                    data={data}
                    closeModalEvent={fecharModalCaixaBobina}

                />

                <ReportCaixaA4
                    visible={visibleImpressCaixaA4}
                    empresa={empresa}
                    supSangria={supSangriaList}
                    resVendas={resumoVendas}
                    resRecebimentos={resumoRecebimento}
                    totSuprimentos={totalSuprimento}
                    totDinheiroVendas={totalDinheiroVenda}
                    totDinheiroRecebimentos={totalDinheiroRecebimento}
                    totSangrias={totalSangria}
                    totGeralSupSangria={totalGeralSuprimentosSangrias}
                    totGeralVendas={totalGeralVendas}
                    totGeralRecebimentos={totalGeralRecebimentos}
                    totGeralApuracao={totalGeralApuracao}
                    data={data}
                    closeModalEvent={fecharModalCaixaA4}

                />

            </div>

        </Template>
    )
}